<template>
  <account>
    <div class="account-profile">
      <div class="container">
        <div class="header">
          <span>ACCOUNT PROFILE</span>
        </div>
        <div class="body">
          <div class="row">
            <div class="child photo">
              <img
                class="img"
                v-if="profileImage != null"
                v-imageLoading="profileImage"
              />
              <img
                class="img"
                v-else
                src="../../assets/images/common/Profile-icon.png"
              />
              <base-button-type-1
                type-color="white"
                text="UPLOAD"
                @click="profileUpload"
              ></base-button-type-1>
              <label class="input-click-box" for="files">
                <input
                  type="file"
                  ref="fileInput"
                  id="files"
                  class="files"
                  multiple="false"
                  accept="image/*"
                  @change="fileChange"
                />
              </label>
            </div>
          </div>
          <div class="line"></div>
          <div class="row">
            <div class="child name">
              <base-input-type-1
                label="FIRST NAME"
                :initValue="initForms.firstName"
                v-on:model="v => setForms('firstName', v)"
              ></base-input-type-1>
              <base-input-type-1
                label="LAST NAME"
                :initValue="initForms.name"
                v-on:model="v => setForms('name', v)"
              ></base-input-type-1>
            </div>
          </div>

          <div class="row">
            <div class="child birthday">
              <base-input-type-1
                label="BIRTHDAY"
                placeholder="YEAR"
                :initValue="initForms.year"
                v-on:model="v => setForms('year', v)"
              ></base-input-type-1>
              <base-input-type-2
                placeholder="MONTH"
                :initValue="initForms.month"
                v-on:model="v => setForms('month', v)"
              ></base-input-type-2>
              <base-input-type-2
                placeholder="DAY"
                :initValue="initForms.day"
                v-on:model="v => setForms('day', v)"
              ></base-input-type-2>
            </div>
          </div>

          <div class="row">
            <div class="child email">
              <base-input-type-1
                :initValue="initForms.email"
                v-on:model="v => setForms('email', v)"
                label="EMAIL ADDRESS"
                placeholder="EMAIL ADDRESS"
              ></base-input-type-1>
            </div>
          </div>

          <div class="row">
            <div class="child mobile-number">
              <base-input-type-1
                label="MOBILE NUMBER"
                placeholder="MOBILE NUMBER"
                :initValue="initForms.mobileNumber"
                v-on:model="v => setForms('mobileNumber', v)"
              ></base-input-type-1>
            </div>
          </div>
        </div>
        <div class="footer">
          <div class="child submit">
            <base-button-type-1
              text="CANCEL"
              type-color="white"
              @click="$router.push({ path: '/photographer/dashboard' })"
            ></base-button-type-1>
            <base-button-type-1 text="OK" @click="save"></base-button-type-1>
          </div>
        </div>
      </div>
      <div class="container">
        <div class="header">
          <span>ABOUT YOU</span>
        </div>
        <div class="body">
          <div class="row">
            <div class="child">
              <base-textarea-type-1
                label="ABOUT ME"
                placeholder="ABOUT ME"
                :initValue="initForms.aboutMe"
                v-on:model="v => setForms('aboutMe', v)"
              ></base-textarea-type-1>
            </div>
          </div>
          <div class="row">
            <div class="child">
              <base-input-type1
                label="EXPERIENCE"
                placeholder="EXPERIENCE"
                :initValue="initForms.experience"
                v-on:model="v => setForms('experience', v)"
              ></base-input-type1>
            </div>
          </div>
          <div class="row">
            <div class="child">
              <LanguageBox v-model="forms.languages" />
            </div>
          </div>
        </div>
        <div class="footer">
          <div class="child submit">
            <base-button-type-1
              text="CANCEL"
              type-color="white"
              @click="$router.push({ path: '/photographer/dashboard' })"
            ></base-button-type-1>
            <base-button-type-1 text="OK" @click="save"></base-button-type-1>
          </div>
        </div>
      </div>
      <div
        class="container"
        style="justify-items: auto; clear: both; display: none"
      >
        <div class="header">
          <span>CHANGE PASSWOARD</span>
        </div>
        <div class="body">
          <div class="row">
            <div class="child">
              <base-input-password-type-1
                label="CURRENT PASSWORD"
                placeholder="CURRENT PASSWORD"
              ></base-input-password-type-1>
            </div>
          </div>
          <div class="row">
            <div class="child">
              <base-input-password-type-1
                label="NEW PASSWORD"
                placeholder="NEW PASSWORD"
              ></base-input-password-type-1>
            </div>
          </div>
          <div class="row">
            <div class="child">
              <base-input-password-type-1
                label="CONFIRM PASSWORD"
                placeholder="CONFIRM PASSWORD"
              ></base-input-password-type-1>
            </div>
          </div>
        </div>
        <div class="footer">
          <div class="child submit">
            <base-button-type-1
              text="CANCEL"
              type-color="white"
              @click="$router.push({ path: '/photographer/dashboard' })"
            ></base-button-type-1>
            <base-button-type-1 text="OK" @click="save"></base-button-type-1>
          </div>
        </div>
      </div>
    </div>
  </account>
</template>

<script>
import Account from './Account'
import Hash from 'object-hash'
import BaseInputType1 from '../common/form-elemnets/BaseInputType1'
import BaseInputType2 from '../common/form-elemnets/BaseInputType2'
import BaseButtonType1 from '../common/form-elemnets/BaseButtonType1'
import BaseTextareaType1 from '../common/form-elemnets/BaseTextareaType1'
import BaseInputPasswordType1 from '../common/form-elemnets/BaseInputPasswordType1'
import { getUser } from '../../api/user'
import { defaultStore, firebaseConnection } from '../../library/firebase'
import * as types from '../../store/mutation-types'
import mixImageLoading from '../../mixin/common'
import LanguageBox from '../common/LanguageBox'

export default {
  mixins: [mixImageLoading],
  name: 'account-profile',
  components: {
    LanguageBox,
    BaseInputPasswordType1,
    BaseTextareaType1,
    BaseButtonType1,
    BaseInputType2,
    BaseInputType1,
    Account
  },
  data() {
    return {
      forms: {
        profileImage: '',
        name: '',
        firstName: '',
        birthday: '',
        year: '',
        month: '',
        day: '',
        email: '',
        mobileNumber: '',
        aboutMe: '',
        experience: '',
        languages: ['English']
      },
      initForms: {},
      tempSize: 400,
      standard: 'height'
    }
  },
  created() {
    this.getUserInfo()
  },
  updated() {
    // console.log(this.forms)
  },
  methods: {
    async save() {
      console.log('save :', this.forms)

      await defaultStore
        .collection('photographers_service')
        .where('uid', '==', this.$store.getters.userInfo.uid)
        .get()
        .then(snap => {
          if (snap.size > 0) {
            return snap.forEach(doc => {
              defaultStore
                .collection('photographers_service')
                .doc(doc.id)
                .update({ languages: this.forms.languages })
                .then(() => {
                  console.log('완료')
                })
            })
          }
        })

      await defaultStore
        .collection('users')
        .doc(this.$store.getters.userInfo.uid)
        .update(this.forms)
        .then(res => {
          console.log('updated success', res)
          this.$store
            .dispatch(types.GET_USERINFO, {
              uid: this.$store.getters.userInfo.uid
            })
            .then(res => {
              console.log(res)
              alert('Success')
            })
        })
    },
    setForms(index, value) {
      this.forms[index] = value
    },
    getUserInfo() {
      getUser(this.$store.getters.userInfo.uid).then(res => {
        console.log('profile:', res)
        this.initForms = res
        this.forms = Object.assign(this.forms, res)
      })
    },
    profileUpload() {
      // console.log(this.$refs.fileInput)
      this.$refs.fileInput.click()
    },
    fileChange(e) {
      // 여기에서 셀렉트 인지 아닌지 체크
      //여기에서 이미지로 저장할 데이터들의 값을 배열로 만들어서 취합한다.
      this.fileUpload(e.target.files)
    },
    fileUpload(file) {
      // console.log('file:', file)
      const fileName = Hash(new Date().getTime() + file[0].name)
      if (file[0].size < 100000) {
        firebaseConnection
          .storage()
          .ref()
          .child('profile_image')
          .child(this.$store.getters.userInfo.uid)
          .child(fileName)
          .put(file[0])
          .then(res => {
            const obj1 = Object.assign(
              { uid: this.$store.getters.userInfo.uid, status: true },
              res.metadata
            )
            console.log(obj1)
            delete obj1.cacheControl
            delete obj1.contentLanguage
            delete obj1.customMetadata
            return defaultStore
              .collection('images')
              .add(obj1)
              .then(doc => {
                console.log(doc)
                this.forms.profileImage = {
                  imageUid: doc.id,
                  fileName: fileName,
                  url: res.metadata.fullPath
                }
                this.$forceUpdate()
              })
          })
      } else {
        alert('Please upload 100KB less size image.')
      }
    },
    reSize(image) {
      const canvas = document.createElement('canvas')
      const files = new FileReader()
      return new Promise(resolve => {
        files.addEventListener('loadstart', () => {
          let img = new Image()
          img.onload = () => {
            if (this.standard === 'width') {
              if (img.width > this.tempSize) {
                img.height *= this.tempSize / img.width
                img.width = this.tempSize
              }
            } else {
              if (img.height > this.tempSize) {
                img.width *= this.tempSize / img.height
                img.height = this.tempSize
              }
            }
            const ctx = canvas.getContext('2d')
            ctx.clearRect(0, 0, canvas.width, canvas.height)
            canvas.width = img.width
            canvas.height = img.height
            ctx.drawImage(img, 0, 0, img.width, img.height)
          }
          console.log('files.result:', files.result)
          img.src = files.result
          console.log('resize1:', img)
          console.log('resize2:', canvas.toDataURL('image/png'))
          resolve(canvas.toDataURL('image/png'))
        })

        files.readAsDataURL(image)
      })
    }
  },
  computed: {
    profileImage() {
      if (this.forms.profileImage) {
        return this.forms.profileImage.url
      } else if (this.initForms.profileImage) {
        return this.initForms.profileImage.url
      } else {
        return null
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.account-profile {
  display: flex;
  justify-content: space-between;
  margin-top: 40px;
  flex-wrap: wrap;

  .container {
    margin-bottom: 20px;
    width: 520px;
    height: auto;
    padding-bottom: 20px;
    background-color: #ffffff;
    border: solid 1px #e7e7e7;

    .header {
      width: 520px;
      height: 50px;
      background-color: #f5f5f5;
      border-bottom: solid 1px #e7e7e7;
      display: flex;
      justify-content: flex-start;
      align-items: center;

      span {
        padding-left: 40px;
      }
    }

    .body {
      padding: 0 40px;
      /*border: 1px solid red;*/
      .line {
        width: 440px;
        height: 1px;
        background-color: #e7e7e7;
        margin: 20px 0 40px 0;
      }

      .row {
        margin-top: 15px;

        .child {
          &.photo {
            position: relative;

            .input-click-box {
              visibility: hidden;
            }

            .img {
              width: 110px;
              height: 110px;
              display: block;
              object-fit: contain;
            }

            .base-button-type-1 {
              top: 36px;
              left: 130px;
              position: absolute;
              width: 190px;
              height: 50px;
            }
          }

          &.name {
            width: 100%;
            display: flex;
            justify-content: space-between;

            .base-input-type-1 {
              width: 208px;
            }
          }

          &.birthday {
            display: flex;
            justify-content: space-between;
            align-items: flex-end;

            .base-input-type-1,
            .base-input-type-2 {
              width: 131px;
            }
          }
        }
      }
    }

    .footer {
      padding: 0 40px;
      margin-top: 30px;
      display: flex;
      justify-content: flex-end;

      .submit {
        display: flex;
        justify-content: space-between;
        width: 320px;
      }
    }
  }
}
</style>
